import { ViewportType } from "./constants";

export const hexToRgb = (hex: string): string | null => {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const fullHex = hex.replace(shorthandRegex, (_m, r, g, b) => {
        return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result ?
        // tslint:disable-next-line: no-magic-numbers
        `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`
        : null;
};

export const isNumber = (value: string | number): boolean => isNaN(Number(value)) === false;

export const getEnumKeys = (input: object): readonly string[] => (
    Object.keys(input)
        .filter(isNumber)
        .map(key => input[key])
);

export const isCharacterALetter = (value: string): boolean => {
    if (value.length !== 1) {
        return false;
    }
    return (/[a-zA-Z]/).test(value);
};

// Checks for IE11, not 100% reliable though, so only use in cases where it's purely to make the IE11 experience
// better, and where it works regardless
export const isIE11 = () =>
    navigator.userAgent.includes("rv:11.0");

// How to check if an object is a readonly array in TypeScript?
// https://stackoverflow.com/a/56249765/1287183
declare global {
    interface ArrayConstructor {
        isArray(arg: ReadonlyArray<any> | any): arg is ReadonlyArray<any>;
    }
}

export type ViewportSlots = { [key in ViewportType]?: number };

export function to2DGridArray<T>(items: readonly T[], numPerRow: number): readonly (readonly T[])[] {
    if (items.length <= 0 || numPerRow === 0) { return []; }

    return items.reduce((rows, item, index) => {
        if (index % numPerRow === 0) {
            rows.push([item]);
        } else {
            rows[rows.length - 1].push(item);
        }
        return rows;
    }, [] as T[][]);
}
